import React from 'react';

function NwuUnescoBanner() {
  return (
    <div className="flex flex-col md:flex-row w-full overflow-hidden p-5 md:h-52">
      {/* Left image */}
      <div className="flex-5 md:flex-[5] flex items-center justify-center bg-white overflow-hidden h-48 md:h-full mb-4 md:mb-0">
        <img
          src="images/banner-sdl.jpg"
          alt="NWU banner"
          className="w-full h-full object-contain"
        />
      </div>

      {/* Right image */}
      <div className="flex-3 md:flex-[3] flex items-center justify-center bg-white overflow-hidden h-48 md:h-full md:ml-4">
        <img
          src="images/banner-unesco.png"
          alt="UNESCO banner"
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
}

export default NwuUnescoBanner;
